/**
 * Safety net so the native cart drawer opens/refreshes even when an item is
 * added by a script we don't control (e.g. the Secomapp/Widebundle "Osta 1/2/3"
 * bundle-tier buttons on the product page, which render their own Add to Cart
 * button instead of using the theme's native product form).
 *
 * It works by watching for any successful call to Shopify's own cart AJAX
 * endpoints (/cart/add(.js), /cart/change(.js), /cart/update(.js)), regardless
 * of which script made the call, then refreshing + opening the native drawer
 * the same way the theme already does for its own forms.
 */
(function () {
  if (window.__cartDrawerExternalSyncPatched) return;
  window.__cartDrawerExternalSyncPatched = true;

  var CART_ENDPOINT_RE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;

  function isOnCartPage() {
    var cartPath = (window.routes && window.routes.cart_url) || '/cart';
    var current = window.location.pathname.replace(/\/$/, '');
    return current === cartPath.replace(/\/$/, '');
  }

  function notifyCartChanged() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-cart-sync' });
    }
    if (isOnCartPage()) return;
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && !drawer.classList.contains('active')) {
        drawer.open();
      }
    }, 350);
  }

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isCartCall = method === 'POST' && CART_ENDPOINT_RE.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartCall) {
        result
          .then(function (response) {
            if (response && response.ok) notifyCartChanged();
          })
          .catch(function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartSyncIsCartCall =
      typeof url === 'string' && method && method.toUpperCase() === 'POST' && CART_ENDPOINT_RE.test(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__cartSyncIsCartCall) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) notifyCartChanged();
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
